import { FORMATIONS_BY_TEAM_SIZE, } from "./types";
const Y_GK = 92;
const Y_DEF_ROW = 70;
const Y_FWD_ROW = 18;
const ROW_X = {
    GK: { 1: [50] },
    D: {
        2: [35, 65],
        3: [25, 50, 75],
        4: [10, 35, 65, 90],
    },
    DM: {
        1: [50],
        2: [38, 62],
        3: [25, 50, 75],
        4: [15, 38, 62, 85],
    },
    M: {
        1: [50],
        2: [35, 65],
        3: [25, 50, 75],
        4: [10, 35, 65, 90],
    },
    AM: {
        1: [50],
        2: [38, 62],
        3: [15, 50, 85],
        4: [10, 35, 65, 90],
    },
    F: {
        1: [50],
        2: [38, 62],
        3: [10, 50, 90],
        4: [10, 35, 65, 90],
    },
};
// Rows of 5 take different shapes depending on the back-row count.
// - D=5 and any row of 5 above a back of ≤ 3: outer two are wingbacks at the
//   touchline (5 / 95) with a tight 30 / 50 / 70 inner trio.
// - M/DM/AM=5 sitting above a back 4 (e.g. 4-5-1): outer two stack on the
//   fullbacks at 10 / 90 — wide mids don't sit further out than their FBs.
const xsForRowOfFive = (band, backCount) => {
    if (band === "D" || backCount <= 3) {
        return [8, 30, 50, 70, 92];
    }
    return [10, 30, 50, 70, 90];
};
const defaultXs = (count) => {
    if (count === 1)
        return [50];
    if (count === 2)
        return [35, 65];
    if (count === 3)
        return [25, 50, 75];
    if (count === 4)
        return [10, 35, 65, 90];
    if (count === 5)
        return [8, 30, 50, 70, 92];
    return Array.from({ length: count }, (_, i) => 10 + (i * 80) / (count - 1));
};
// id stays L/R-prefixed for uniqueness; label drops the side for central roles.
// Reads tactically: e.g. a back 4 has LB / CB / CB / RB on screen, not
// LB / LCB / RCB / RB. LCB / RCB stay only in a back 5.
const positionPairs = (band, count) => {
    if (band === "D") {
        if (count === 1)
            return [{ id: "CB", label: "CB" }];
        if (count === 2)
            return [
                { id: "LCB", label: "CB" },
                { id: "RCB", label: "CB" },
            ];
        if (count === 3)
            return [
                { id: "LCB", label: "CB" },
                { id: "CB", label: "CB" },
                { id: "RCB", label: "CB" },
            ];
        if (count === 4)
            return [
                { id: "LB", label: "LB" },
                { id: "LCB", label: "CB" },
                { id: "RCB", label: "CB" },
                { id: "RB", label: "RB" },
            ];
        if (count === 5)
            return [
                { id: "LWB", label: "LWB" },
                { id: "LCB", label: "LCB" },
                { id: "CB", label: "CB" },
                { id: "RCB", label: "RCB" },
                { id: "RWB", label: "RWB" },
            ];
    }
    if (band === "F") {
        if (count === 1)
            return [{ id: "ST", label: "ST" }];
        if (count === 2)
            return [
                { id: "LF", label: "ST" },
                { id: "RF", label: "ST" },
            ];
        if (count === 3)
            return [
                { id: "LW", label: "LW" },
                { id: "CF", label: "CF" },
                { id: "RW", label: "RW" },
            ];
        if (count === 4)
            return [
                { id: "LW", label: "LW" },
                { id: "LF", label: "ST" },
                { id: "RF", label: "ST" },
                { id: "RW", label: "RW" },
            ];
    }
    if (band === "M") {
        if (count === 1)
            return [{ id: "CM", label: "CM" }];
        if (count === 2)
            return [
                { id: "LCM", label: "CM" },
                { id: "RCM", label: "CM" },
            ];
        if (count === 3)
            return [
                { id: "LCM", label: "CM" },
                { id: "CDM", label: "CDM" },
                { id: "RCM", label: "CM" },
            ];
        if (count === 4)
            return [
                { id: "LM", label: "LM" },
                { id: "LCM", label: "CM" },
                { id: "RCM", label: "CM" },
                { id: "RM", label: "RM" },
            ];
        if (count === 5)
            return [
                { id: "LM", label: "LM" },
                { id: "LCM", label: "CM" },
                { id: "CDM", label: "CDM" },
                { id: "RCM", label: "CM" },
                { id: "RM", label: "RM" },
            ];
    }
    if (band === "DM") {
        if (count === 1)
            return [{ id: "CDM", label: "CDM" }];
        if (count === 2)
            return [
                { id: "LDM", label: "CDM" },
                { id: "RDM", label: "CDM" },
            ];
        if (count === 3)
            return [
                { id: "LDM", label: "CDM" },
                { id: "CDM", label: "CDM" },
                { id: "RDM", label: "CDM" },
            ];
        if (count === 4)
            return [
                { id: "LDM", label: "CDM" },
                { id: "LCDM", label: "CDM" },
                { id: "RCDM", label: "CDM" },
                { id: "RDM", label: "CDM" },
            ];
        if (count === 5)
            return [
                { id: "LWB", label: "LWB" },
                { id: "LDM", label: "CDM" },
                { id: "CDM", label: "CDM" },
                { id: "RDM", label: "CDM" },
                { id: "RWB", label: "RWB" },
            ];
    }
    if (band === "AM") {
        if (count === 1)
            return [{ id: "CAM", label: "CAM" }];
        if (count === 2)
            return [
                { id: "LAM", label: "CAM" },
                { id: "RAM", label: "CAM" },
            ];
        if (count === 3)
            return [
                { id: "LW", label: "LW" },
                { id: "CAM", label: "CAM" },
                { id: "RW", label: "RW" },
            ];
        if (count === 4)
            return [
                { id: "LW", label: "LW" },
                { id: "LAM", label: "CAM" },
                { id: "RAM", label: "CAM" },
                { id: "RW", label: "RW" },
            ];
        if (count === 5)
            return [
                { id: "LW", label: "LW" },
                { id: "LAM", label: "CAM" },
                { id: "CAM", label: "CAM" },
                { id: "RAM", label: "CAM" },
                { id: "RW", label: "RW" },
            ];
    }
    // Generic fallback for hypothetical bands/counts not covered above.
    if (count === 1)
        return [{ id: `C${band}`, label: `C${band}` }];
    if (count === 2)
        return [
            { id: `L${band}`, label: `L${band}` },
            { id: `R${band}`, label: `R${band}` },
        ];
    if (count === 3)
        return [
            { id: `L${band}`, label: `L${band}` },
            { id: `C${band}`, label: `C${band}` },
            { id: `R${band}`, label: `R${band}` },
        ];
    if (count === 4)
        return [
            { id: `L${band}`, label: `L${band}` },
            { id: `LC${band}`, label: `LC${band}` },
            { id: `RC${band}`, label: `RC${band}` },
            { id: `R${band}`, label: `R${band}` },
        ];
    if (count === 5)
        return [
            { id: `L${band}`, label: `L${band}` },
            { id: `LC${band}`, label: `LC${band}` },
            { id: `C${band}`, label: `C${band}` },
            { id: `RC${band}`, label: `RC${band}` },
            { id: `R${band}`, label: `R${band}` },
        ];
    return Array.from({ length: count }, (_, i) => ({
        id: `${band}${i + 1}`,
        label: `${band}${i + 1}`,
    }));
};
const rowY = (rowIdx, totalRows) => {
    if (totalRows <= 1)
        return (Y_DEF_ROW + Y_FWD_ROW) / 2;
    return Y_DEF_ROW - (rowIdx * (Y_DEF_ROW - Y_FWD_ROW)) / (totalRows - 1);
};
const bandForRow = (rowIdx, totalRows) => {
    if (rowIdx === 0)
        return "D";
    if (rowIdx === totalRows - 1)
        return "F";
    const midCount = totalRows - 2;
    const midIdx = rowIdx - 1;
    if (midCount === 1)
        return "M";
    return midIdx === 0 ? "DM" : "AM";
};
// Y offsets stagger players within a row so a 4-3-3 isn't drawn as 3 flat lines.
// Positive = deeper (closer to own goal); negative = higher up the pitch.
const yOffsetForPosition = (band, count, idx, totalRows) => {
    // 3-forward row (4-3-3, 3-4-3, etc.): CF pushed up, wingers a touch behind.
    if (band === "F" && count === 3) {
        return idx === 1 ? -4 : 2;
    }
    // Lone central midfield row of 3 (e.g. 4-3-3): inverted triangle with CDM deepest.
    if (band === "M" && count === 3 && totalRows === 3) {
        return idx === 1 ? 3 : -2;
    }
    // Three attacking mids (4-2-3-1 style): wide AMs push up like wingers, CAM hangs back.
    if (band === "AM" && count === 3) {
        return idx === 1 ? 2 : -1;
    }
    // 5-mid row (4-5-1, 3-5-2): holding mid sits deeper, box-to-box mids forward,
    // wide mids on the row baseline.
    if (band === "M" && count === 5) {
        if (idx === 2)
            return 5;
        if (idx === 1 || idx === 3)
            return -2;
        return 0;
    }
    // Back 5 (5-3-2, 5-4-1, etc.): wingbacks push high in the attacking shape,
    // halfway toward the next row up, while CBs hold the defensive line.
    if (band === "D" && count === 5 && (idx === 0 || idx === 4)) {
        const nextRowY = totalRows > 1 ? rowY(1, totalRows) : Y_FWD_ROW;
        return (nextRowY - Y_DEF_ROW) / 2;
    }
    return 0;
};
export const slotsForFormation = (formation) => {
    const parts = formation.split("-").map(Number);
    const totalRows = parts.length;
    const slots = [{ id: "GK", label: "GK", band: "GK", x: 50, y: Y_GK }];
    const backCount = parts[0] ?? 0;
    parts.forEach((count, rowIdx) => {
        if (count === 0)
            return;
        const band = bandForRow(rowIdx, totalRows);
        const baseY = rowY(rowIdx, totalRows);
        const xs = count === 5
            ? xsForRowOfFive(band, backCount)
            : ROW_X[band]?.[count] ?? defaultXs(count);
        const pairs = positionPairs(band, count);
        xs.forEach((x, i) => {
            const y = baseY + yOffsetForPosition(band, count, i, totalRows);
            const pair = pairs[i];
            slots.push({ id: pair.id, label: pair.label, band, x, y });
        });
    });
    return slots;
};
export const defaultFormationForTeamSize = (size) => FORMATIONS_BY_TEAM_SIZE[size][0];
